/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-props-no-spreading */
import 'ui/scss/app.scss';
import 'ui/scss/bootstrap/bootstrap-grid.min.css';
import 'react-toastify/dist/ReactToastify.min.css';

import 'utils/modernizr';

import React, { useEffect, useLayoutEffect, useState } from 'react';

import Amplify from 'aws-amplify';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Redirect, Route, Router, Switch } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';

import awsconfig from 'aws-config';
import {
  AddPersonalData,
  ForgotPassword,
  Login,
  TermsAndConditions
} from 'pages';

import CreatePassword from 'pages/ForgotPassword/createPassword';

import { GET_CURRENT_USER, SIGNOUT } from 'redux/sagas/actions/authentication';

import {
  GET_CHARGING_META_DATA,
  GET_DOMAINS_FOR_FILTERS
} from 'redux/sagas/actions/dashboard';
import { SET_CONFIG } from 'redux/slices/app';
import routes from 'routing/routes';

import { NoProfile, ScrollToTop } from 'ui/atoms';

import { AccessLayout, GlobalLayout, Loader, Toast } from 'ui/components';
import { ModalsPortal } from 'ui/components/Modals';
import theme from 'ui/theme';

import './i18n';
import { getCookie } from 'utils/cookies';

import PartnerSwitch from './routing/PartnerSwitch';

const App = ({
  user,
  getCurrentUser,
  signOut,
  isLoadingUser,
  role,
  getChargingMetaCorporate,
  getChargingMeta,
  setConfig,
  phoneNumber,
  lastName,
  firstName,
  acceptedTc,
  history,
  config
}) => {
  const [isLoadingApp, setIsLoadingApp] = useState(true);

  useEffect(() => {
    setConfig(config);
    awsconfig(config)
      .then(a => {
        Amplify.configure(a);
        getCurrentUser();
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log('Error onInit Configuration', err));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loginStore = getCookie('loginStore');

  useEffect(() => {
    if (loginStore && loginStore !== 'localStorage') {
      setTimeout(() => {
        signOut();
      }, 1000 * 60 * 60);
    }
  }, [loginStore, signOut]);

  useEffect(() => {
    if (!isLoadingUser) {
      setIsLoadingApp(false);
      if (user) {
        //  getChargingMeta();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingUser, role, user]);

  useLayoutEffect(() => {
    const detectZoom = () => {
      const isMac = window.navigator.platform.includes('Mac');
      const zoomPage = Math.round(
        (window.devicePixelRatio - (isMac ? 1 : 0)) * 100
      );
      const html = document.querySelector('html');
      if (zoomPage > 100) {
        html.classList.add('zoomed130');
      }
      if (zoomPage > 130) {
        html.classList.add('zoomed150');
      }
    };

    window.addEventListener('resize', detectZoom);
    detectZoom();
  }, []);

  if (isLoadingApp) {
    return (
      <ThemeProvider theme={theme('#258900')}>
        <Loader isLoading />
      </ThemeProvider>
    );
  }

  if (!isLoadingApp && user && !role) {
    return (
      <ThemeProvider theme={theme('#258900')}>
        <AccessLayout>
          <NoProfile />
        </AccessLayout>
      </ThemeProvider>
    );
  }
  const loadTCorApp = () => {
    if (!acceptedTc) {
      return (
        <>
          {' '}
          <ScrollToTop />
          <GlobalLayout role={role}>
            <PartnerSwitch routes={routes} />
          </GlobalLayout>
        </>
      );
    }
    return <TermsAndConditions />;
  };
  return (
    <ThemeProvider theme={theme('#258900')}>
      <Router history={history}>
        {user && phoneNumber && lastName && firstName ? (
          loadTCorApp()
        ) : (
          <AccessLayout>
            <Switch>
              {user && (!phoneNumber || !lastName || !firstName) ? (
                <>
                  <Route
                    path={routes.personalData.path}
                    render={() => <AddPersonalData />}
                  />
                  <Redirect to={routes.personalData.path} />
                </>
              ) : (
                <>
                  <Route path={routes.signin.path} render={() => <Login />} />
                  <Route
                    path={routes.forgotpassword.path}
                    render={() => <ForgotPassword />}
                  />
                  <Route
                    path={routes.createNewPassword.path}
                    render={() => <CreatePassword />}
                  />
                  <Redirect to={routes.signin.path} />
                </>
              )}
            </Switch>
          </AccessLayout>
        )}
      </Router>
      <ModalsPortal.Target />
      <Toast />
      <Loader />
    </ThemeProvider>
  );
};

App.propTypes = {
  user: PropTypes.object,
  getCurrentUser: PropTypes.func,
  signOut: PropTypes.func,
  isLoadingUser: PropTypes.bool,
  role: PropTypes.string,
  getChargingMeta: PropTypes.func,
  getChargingMetaCorporate: PropTypes.func,
  setConfig: PropTypes.func,
  phoneNumber: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  acceptedTc: PropTypes.bool,
  history: PropTypes.object,
  config: PropTypes.object
};

export default connect(
  ({ authentication }) => ({
    user: authentication.user,
    isLoadingUser: authentication.isLoadingUser,
    role: authentication?.role,
    phoneNumber: authentication?.accountInfo?.phoneNumber,
    firstName: authentication?.accountInfo?.name,
    lastName: authentication?.accountInfo?.surname,
    acceptedTc: authentication?.accountInfo?.acceptedTc
  }),
  dispatch => ({
    getCurrentUser: () => dispatch({ type: GET_CURRENT_USER._REQUEST }),
    signOut: () => dispatch({ type: SIGNOUT._REQUEST }),
    getChargingMeta: () => dispatch({ type: GET_CHARGING_META_DATA._REQUEST }),
    getChargingMetaCorporate: () =>
      dispatch({ type: GET_DOMAINS_FOR_FILTERS._REQUEST }),
    setConfig: payload => dispatch(SET_CONFIG(payload))
  })
)(App);
